import { Box } from "@mui/material";
import { useMemo, useState } from "react";

/** Icons */
import { TabContentWrapper } from "../TabContentWrapper";
import { Platforms } from "./Platforms";

export const ProfileSummary = ({ details, onPlatformClick }) => {
  // console.log("details profile summary", details);
  const [value, setValue] = useState("platforms");

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const getContentForTab = useMemo(() => {
    switch (value) {
      case "platforms":
        return (
          <Platforms details={details} onPlatformClick={onPlatformClick} />
        );
      case "content":
        return <Box>Content</Box>;
      default:
        return null;
    }
  }, [value, details]);

  return (
    <TabContentWrapper tab={value} onTabChange={handleChange}>
      {getContentForTab}
    </TabContentWrapper>
  );
};
